// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_GH1","cls2":"CreateSocialItem-cls2_JbD CreateSocialItem-cls1_GH1"};